// extracted by mini-css-extract-plugin
export default {"modal-title":"yuEi2XvHVgOgrWJAmXOA","product-register-modal":"At63VyXIR0hL3xwtixio"};